<script>
  export let src;
  export let alt;
  export let css = "";
  export let onClick = () => {};

  import IntersectionObserver from "./IntersectionObserver.svelte";
  import Image from "./Image.svelte";

  let nativeLoading = false;

  // Determine whether to bypass our intersecting check
  // onMount(() => {
  //   if ('loading' in HTMLImageElement.prototype) {
  //     nativeLoading = true
  //   }
  // })
</script>

<IntersectionObserver once={true} let:intersecting>
  {#if intersecting || nativeLoading}
    <Image {css} {alt} {src} {onClick} />
  {/if}
</IntersectionObserver>
